import { takeLatest } from "redux-saga/effects";
import { apis } from "../../config/APIs";
import { sagaFunctions } from "../../utils";
import {
  Employees,
  AddEmployees,
  DeleteEmployees,
  EmployeesStatus,
  UpdateEmployees,
  UploadBulk,
  DownloadBulkLink,
  GetUserFields,
  GetUsersList,
  GetProfile,
} from "./employees";

function getUsersList(req) {
  return sagaFunctions(GetUsersList, "get", apis.usersList, req.payload, {
    skipSuccessMessage: true,
  })();
}
function getProfile(req) {
  return sagaFunctions(GetProfile, "get", apis.profile, req.payload, {
    skipSuccessMessage: true,
  })();
}
function getEmployees(req) {
  return sagaFunctions(
    Employees,
    "get",
    apis.employees,
    req.payload,
    ["search"].includes(req.payload)
      ? {}
      : {
          headers: {
            "Content-Type": "multipart/formdata",
          },
          skipSuccessMessage: true,
        },
  )();
}

function updateEmployeesStatus(req) {
  return sagaFunctions(
    EmployeesStatus,
    "post",
    apis.employeesStatus,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
      Authorization: sessionStorage.getItem("token"),
    },
  )();
}

function uploadBulkEmployees(req) {
  return sagaFunctions(UploadBulk, "post", apis.uploadUsers, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

function downloadBulk() {
  return sagaFunctions(DownloadBulkLink, "get", apis.importUserTemplate)();
}

function getUserFields() {
  return sagaFunctions(GetUserFields, "get", apis.userFields)();
}

function addEmployees(req) {
  return sagaFunctions(AddEmployees, "post", apis.employees, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

function updateEmployees(req) {
  return sagaFunctions(
    UpdateEmployees,
    "post",
    apis.updateEmployees,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function deleteEmployees(req) {
  return sagaFunctions(
    DeleteEmployees,
    "post",
    apis.updateEmployees,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

export function* employeesWatcher() {
  yield takeLatest(Employees.REQUEST, getEmployees);
  yield takeLatest(GetUsersList.REQUEST, getUsersList);
  yield takeLatest(EmployeesStatus.REQUEST, updateEmployeesStatus);
  yield takeLatest(AddEmployees.REQUEST, addEmployees);
  yield takeLatest(UpdateEmployees.REQUEST, updateEmployees);
  yield takeLatest(DeleteEmployees.REQUEST, deleteEmployees);
  yield takeLatest(DownloadBulkLink.REQUEST, downloadBulk);
  yield takeLatest(UploadBulk.REQUEST, uploadBulkEmployees);
  yield takeLatest(GetUserFields.REQUEST, getUserFields);
  yield takeLatest(GetProfile.REQUEST, getProfile);
}
